import * as _utils from './utils';
import { createWixCodeCollectionsAPI } from './wixCodeCollectionsAPI';

export const utils = {
  ..._utils,
  createWixCodeCollectionsAPI,
};
